import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { setupHead } from "./utils/head";
import { App } from "./App";

// Runs before React renders so the hero image and fonts are discovered as
// early as possible (LCP request discovery + no render-blocking stylesheet).
setupHead();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-230" data-mp="2abfap21kjinq" />);
}